import InfoCirleIcon from '@svg/info-circle.svg';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './FlashMessage.module.scss';

function FlashMessage({ type, message }) {
  return (
    <p className={classNames('u-mb-0', styles.flashMessage, styles[type])}>
      {type === 'info' && <InfoCirleIcon />}
      {message}
    </p>
  );
}

FlashMessage.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'info', 'warning']).isRequired,
  message: PropTypes.string.isRequired,
};

export default FlashMessage;
